import { TextField, TextFieldProps } from '@mui/material'
import { ChangeEvent } from 'react'

type DriverJurisdictionTextFieldProps = Omit<TextFieldProps, 'type'>

export default function DriverJurisdictionTextField({
  inputProps,
  onChange,
  ...textFieldProps
}: DriverJurisdictionTextFieldProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    event.target.value = event.target.value
      .toUpperCase()
      .replace(/[^A-Z-]/g, '')
      .slice(0, 2)

    onChange?.(event)
  }

  return (
    <TextField
      {...textFieldProps}
      inputProps={{
        ...inputProps,
        autoCapitalize: 'characters',
        maxLength: 2,
        pattern: '[A-Z-]{0,2}'
      }}
      onChange={handleChange}
      type='text'
    />
  )
}
